module.exports = __webpack_public_path__ + "img/test-drive-custom_route.ed8d1dad.svg";